import { Chip, type ChipProps, type SxProps, type Theme } from '@mui/material';

interface CaseStatusBadgeProps {
  status: string;
}

interface StatusStyle {
  color: ChipProps['color'];
  sx?: SxProps<Theme>;
}

function getStatusStyle(status: string): StatusStyle {
  switch (status) {
    // Goal statuses
    case 'Goal Met':
      return { color: 'success' };
    case 'In Progress':
      return { color: 'info' };
    case 'Goal Partially Met':
      return { color: 'warning' };
    case 'Goal Unmet':
      return { color: 'error' };
    case 'Goal Abandoned':
      return { color: 'default' };
    case 'No Resources to Meet Goal':
      return { color: 'default', sx: { bgcolor: '#6a1b9a', color: '#fff', '& .MuiChip-label': { color: '#fff' } } };
    // Case / referral statuses
    case 'Open':
    case 'Active':
    case 'Provided':
      return { color: 'success' };
    case 'Review':
    case 'Monitoring':
    case 'Referred':
      return { color: 'info' };
    case 'Pending':
    case 'On Wait List':
      return { color: 'warning' };
    case 'Closed':
      return { color: 'default' };
    default:
      return { color: 'error' };
  }
}

export function CaseStatusBadge({ status }: CaseStatusBadgeProps) {
  const { color, sx } = getStatusStyle(status);
  return (
    <Chip
      label={status}
      color={color}
      size="small"
      sx={{ minWidth: 120, justifyContent: 'center', ...sx }}
    />
  );
}
